// -----------------------------------------------------------------------------
// Counter User clicks
// -----------------------------------------------------------------------------

import constants from '../constants';

const init = () => {
  initEventListeners();
};

/**
 * Event-Listeners initialisieren
 */
const initEventListeners = () => {
  $(document).on('click', '.js-counter-add', function (event) {
    add($(event.target));
  });
};

/**
 * Counter für User Clicks
 */
const add = ($elem) => {
  const counterType = $elem.attr('data-counter-type');
  const userId = $elem.attr('data-user-id');

  $.ajax({
    url: `${constants.basePath}/counter/${userId}/add`,
    method: 'POST',
    data: {
      counterType
    }
  });
};

export {
  init
};
